import { Component } from '@angular/core';

import { Its2RequestSearchResult } from '@common/models/search-result';

import { SpecificComponent } from '../specific.component';

@Component({
    selector: 'aa-search-result-its2-request',
    templateUrl: './its2-request.component.html',
    styleUrls: [
        './its2-request.component.scss'
    ],
    standalone: false
})
export class Its2RequestComponent extends SpecificComponent<Its2RequestSearchResult>
{
    constructor ()
    {
        super();
    }
}
